import React, { useState } from "react";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import TextArea from "../ReusableComponents/TextArea";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import { roomMasterHeader } from "../components/HeaderAttribute";
import MainPopup from "../popup-containers/MainPopup";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import RoomMasterPopup from "../popup-containers/RoomMasterPopup";
import InputText from "../ReusableComponents/InputText";
// import { IUDAPI } from "../services/APIConnection";
import toast from "react-hot-toast";
import { useEffect } from "react";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import Loader from "../ReusableComponents/Loader";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
const RoomMaster = () => {
  // UI state management
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [roomTypeDD, setRoomTypeDD] = useState([]);
  // Form data and error handling
  const [popUpData, setpopUpData] = useState({});
  const [formFields, setFormFields] = useState({
    mstRoomMasterID: "",
    roomName: "",
    mstRoomTypeId: "",
    description: "",
  });
  const [formFieldsError, setFormFieldsError] = useState({
    roomNameError: "",
    roomTypeError: "",
    descriptionError: "",
  });

  // Grid data

  const [bindRoomMasterDatas, setBindRoomMasterDatas] = useState([]);

  var createdBy = sessionStorage.getItem("createdBy"); // user session

  var mstClientId = sessionStorage.getItem("MstClientId");

  // Load data on mount
  useEffect(() => {
    // bind gird datas
    BindRoomMaster();
  }, []);

  // Fetch grid data from API
  const BindRoomMaster = async () => {
    const data = {
      mstClientId: mstClientId,
    };
    setIsLoading(true);
    const response = await BindPostAPI(data, "RoomMasterAPI/BindRoomMaster");

    if (response && response.data) {
      setBindRoomMasterDatas(response.data.Table);
      const roomTypeDD = response?.data?.Table1.map((item) => ({
        value: item?.MstRoomtypeId,
        label: item?.RoomType,
        maxRooms: item?.NoOfRooms, 
      }));

      setRoomTypeDD(roomTypeDD);
      setIsLoading(false);
    } else {
      setBindRoomMasterDatas([]);
    }
  };

  // Validate form before submit
  const validateForm = () => {
    const formFieldsError = {
      roomNameError: formFields.roomName ? "" : "Enter Room",
      roomTypeError: formFields.mstRoomTypeId ? "" : "Select Room Type",
    };
  };

  // Show add form
  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(false);
    setAddScreenTitle(true);
  };

  // Cancel and reset form
  const cancel = async () => {
    BindRoomMaster();
    setVisibleAdd(false);
    setVisibleTable(true);
    setIsLoading(false);
    setpopUpOpen(false);
    setSubmitBtnDisabled(false);
    setFormFields({
      roomName: "",
      mstRoomTypeId: "",
    });
    setFormFieldsError({
      roomNameError: "",
      roomTypeError: "",
    });
  };

  // Open popup
  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  // Handle popup actions (view/delete/Active/In Active)
  const handleRoomMaster = (rowIndex, flag) => {
    handleOpen(true);

    // Set the appropriate action state based on flag
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }

    // Set selected record data
    setFormFields({
      ...formFields,
      mstRoomMasterID: bindRoomMasterDatas[rowIndex].MstRoomMasterID,
      roomName: bindRoomMasterDatas[rowIndex].RoomName,
      mstRoomTypeId: bindRoomMasterDatas[rowIndex].MstRoomTypeId,
      description: bindRoomMasterDatas[rowIndex].Description,
    });
    setpopUpData(bindRoomMasterDatas[rowIndex]);
  };

  // Handle edit button click
  const handleEdit = (rowIndex) => {
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);

    // Populate form with selected row data
    setFormFields({
      ...formFields,
      mstRoomMasterID: bindRoomMasterDatas[rowIndex].MstRoomMasterID,
      roomName: bindRoomMasterDatas[rowIndex].RoomName,
      mstRoomTypeId: bindRoomMasterDatas[rowIndex].MstRoomTypeId,
      description: bindRoomMasterDatas[rowIndex].Description,
    });
  };

  const handleBlur = (fieldName) => {
    let updatedErrors = { ...formFieldsError };

    /* ---------- Room Type ---------- */
    if (fieldName === "mstRoomTypeId") {
      updatedErrors.roomTypeError = formFields.mstRoomTypeId
        ? ""
        : "Select Room Type";
    }

    /* ---------- Room Name ---------- */
    if (fieldName === "roomName") {
      updatedErrors.roomNameError = formFields.roomName?.trim()
        ? ""
        : "Enter Room";
    }

    /* ---------- Duplicate Check (COMMON) ---------- */
    if (formFields.roomName?.trim() && formFields.mstRoomTypeId) {
      const isDuplicate = bindRoomMasterDatas.some(
        (data) =>
          data.MstRoomTypeId === Number(formFields.mstRoomTypeId) &&
          data.RoomName.trim().toLowerCase() ===
            formFields.roomName.trim().toLowerCase() &&
          data.MstRoomMasterID !== formFields.mstRoomMasterID
      );

      if (isDuplicate) {
        updatedErrors.roomNameError =
          "This room name is already available for this room type.";
      }
    }
    if (formFields.mstRoomTypeId) {
      const selectedRoomType = roomTypeDD.find(
        (x) => Number(x.value) === Number(formFields.mstRoomTypeId)
      );
    
      const currentCount = bindRoomMasterDatas.filter(
        (data) =>
          Number(data.MstRoomTypeId) === Number(formFields.mstRoomTypeId)
      ).length;
    
      const adjustedCount = formFields.mstRoomMasterID
        ? currentCount - 1
        : currentCount;
    
      if (adjustedCount >= selectedRoomType?.maxRooms) {
        updatedErrors.roomNameError = `Only ${selectedRoomType.maxRooms} rooms allowed for this room type.`;
      }
    }

    setFormFieldsError(updatedErrors);

    return Object.values(updatedErrors).every((msg) => msg === "");
  };

  const handleFieldsChange = (value, name) => {
    setFormFields({
      ...formFields,
      [name]: value,
    });
  };

  let isFormValidCheck;
  // Submit form for add/update/delete/Active/In Active

  const handleSubmit = async (items, flag) => {
    let errors = {
      roomTypeError: "",
      roomNameError: "",
    };

    /* ---------- Room Type ---------- */
    if (!formFields.mstRoomTypeId) {
      errors.roomTypeError = "Select Room Type";
    }

    /* ---------- Room Name ---------- */
    if (!formFields.roomName || !formFields.roomName.trim()) {
      errors.roomNameError = "Enter Room";
    }

    /* ---------- Duplicate Check ---------- */
    if (formFields.roomName?.trim() && formFields.mstRoomTypeId) {
      const isDuplicate = bindRoomMasterDatas.some(
        (data) =>
          data.MstRoomTypeId === Number(formFields.mstRoomTypeId) &&
          data.RoomName.trim().toLowerCase() ===
            formFields.roomName.trim().toLowerCase() &&
          data.MstRoomMasterID !== formFields.mstRoomMasterID
      );

      if (isDuplicate) {
        errors.roomNameError =
          "This room name is already available for this room type.";
      }
    }

    if (formFields.mstRoomTypeId) {
      const selectedRoomType = roomTypeDD.find(
        (x) => Number(x.value) === Number(formFields.mstRoomTypeId)
      );
    
      const currentCount = bindRoomMasterDatas.filter(
        (data) =>
          Number(data.MstRoomTypeId) === Number(formFields.mstRoomTypeId)
      ).length;
    
 
      const adjustedCount = formFields.mstRoomMasterID
        ? currentCount - 1
        : currentCount;
    
      if (adjustedCount >= selectedRoomType?.maxRooms) {
        errors.roomNameError = `Only ${selectedRoomType.maxRooms} rooms allowed for this room type.`;
      }
    }

    /* ---------- SET ERRORS ---------- */
    setFormFieldsError(errors);

    /* ---------- STOP SUBMIT ---------- */
    const isValid = Object.values(errors).every((e) => e === "");
    if (!isValid) {
      setIsOpen(true);
      return;
    }

    console.log(isFormValidCheck);

    // Handle Add
    if (flag == 1 || flag == 2) {
      if (isValid) {
        // setIsOpen(true);
        setIsLoading(true);
        setSubmitBtnDisabled(true);
        const payload = {
          MstRoomMasterID: formFields.mstRoomMasterID
            ? formFields.mstRoomMasterID
            : 0,
          mstClientId: mstClientId,
          roomName: formFields.roomName,
          mstRoomTypeId: formFields.mstRoomTypeId,
          Description: formFields.description,
          Createdby: parseInt(createdBy, 10),
          Flag: flag,
        };

        const response = await IUDAPI(payload, "RoomMasterAPI/IUDRoomMaster");

        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Rooms Added Successfully 👍", {
              duration: 1000,
              position: "top-center",
            });

            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to add Rooms data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }

          // Handle Update
        } else if (flag == 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Rooms  updated successfully 👍", {
              duration: 5000,
              position: "top-center",
            });
            setTimeout(cancel, 5000);
          } else {
            toast.error("Failed to update Rooms data 👎", {
              duration: 2000,
              position: "top-center",
            });
            setTimeout(cancel, 2000);
          }
        }
      } else {
        setIsLoading(false);
        setSubmitBtnDisabled(false);
        setIsOpen(true);
      }
    } else {
      setSubmitBtnDisabled(true);
      const data = {
        MstRoomMasterID: formFields.mstRoomMasterID,
        createdby: parseInt(createdBy, 10),
        flag: flag,
      };

      const response = await IUDAPI(data, "RoomMasterAPI/IUDRoomMaster");

      // Handle Delete
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success("Rooms data deleted successfully 🗑️", 5000, cancel());
        } else {
          toast.error("Failed to delete Rooms data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
        // Handle In Active
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success(
            "Rooms Data In Activated successfully 🚫",
            5000,
            cancel()
          );
          cancel();
        } else {
          toast.error("Failed to In Active Rooms data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }

        // Handle Active
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success("Rooms Data Activated successfully ✅", 5000, cancel());
          cancel();
        } else {
          toast.error("Failed to In Active Rooms data 👎", {
            duration: 2000,
            position: "top-center",
          });
          setTimeout(cancel, 2000);
        }
      }
    }
  };

  return (
    <MainLayout pageName={"2"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Rooms"
          header={roomMasterHeader}
          records={bindRoomMasterDatas}
          handleAction={handleRoomMaster}
          handleEdit={handleEdit}
          blockView={true}
          showAdd={showAdd}
        />
      )}
      {visibleAdd && (
        <div>
          <AddScreenTitle
            title="Rooms"
            addScreenTitle={addScreenTitle}
            updateScreenTitle={updateScreenTitle}
          />

          <div class="mx-auto  md:w-[500px] w-full">
            <div class="relative w-full h-full max-w-xl md:h-auto">
              <div class="relative bg-white rounded-lg shadow ">
                <div class="px-6 py-6 lg:px-8">
                  <form class="space-y-6" action="#">
                    <AutoDropDown
                      name="mstRoomTypeId"
                      title="Room Type"
                      options={roomTypeDD}
                      placeholder="Select Room Type"
                      Class="custom-class"
                      disabled={false}
                      classStar="text-red-500"
                      errorMessage={formFieldsError.roomTypeError}
                      selectedOption={
                        roomTypeDD.find(
                          (x) => Number(x.value) === Number(formFields.mstRoomTypeId)
                        ) || null
                      }
                      controlFunc={(selected) => {
                        if (!selected) {
                          setFormFields((prev) => ({
                            ...prev,
                            mstRoomTypeId: "",
                          }));
                          return;
                        }
                      
                        setFormFields((prev) => ({
                          ...prev,
                          mstRoomTypeId: selected.value,
                        }));
                      
                        handleBlur("roomName");
                      }}
                      controlFuncBlur={() => handleBlur("mstRoomTypeId")}
                      // tabIndex="1"
                    />

                    <InputText
                      inputType="text"
                      title="Room"
                      name="roomName"
                      content={formFields.roomName}
                      controlFunc={(e) => {
                        const value = e.target.value;

                        setFormFields((prev) => ({
                          ...prev,
                          roomName: value,
                        }));

                        // Live validation when error exists
                        if (formFieldsError.roomNameError) {
                          handleBlur("roomName");
                        }
                      }}
                      controlFuncBlur={() => handleBlur("roomName")}
                      classStar="text-red-500"
                      isRequired={true}
                      placeholder="Enter Room"
                      errorMessage={formFieldsError.roomNameError}
                      disabled={!formFields.mstRoomTypeId}
                    />

                    <TextArea
                      inputType="text"
                      title="Description"
                      name="description"
                      rows={7}
                      placeholder="Enter Description"
                      maxLength={500}
                      controlFunc={(e) => {
                        setFormFields({
                          ...formFields,
                          description: e.target.value,
                        });
                      }}
                      disabled={false}
                      content={formFields.description}
                    />
                    <Buttons
                      addScreenTitle={addScreenTitle}
                      updateScreenTitle={updateScreenTitle}
                      handleSubmit={handleSubmit}
                      cancel={cancel}
                      disabledBtn={submitBtnDisabled ? true : false}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleRoomMaster}
      >
        <div>
          <PopUpScreenTitle
            title="Rooms"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />

          <RoomMasterPopup data={popUpData} data1={formFields.mstRoomTypeId} />
        </div>

        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};
export default RoomMaster;
